import React from "react";
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { checkPermissions } from '@comps/commonFunctions';


const BaseCreate = (props) =>
  <Button disabled={ !checkPermissions(props.modKey, 'create') } className={ "create-button" } type="primary" { ...props } ><PlusOutlined /> { props.text ? props.text : "Create" } </Button>

export default BaseCreate;
